import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';
import { useLocation, useNavigate } from "react-router-dom";

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0b0f14, #0a0a0c)",
    color: "#e7e7e9",
    padding: "32px 16px 48px",
    fontFamily: "'Pretendard', 'Noto Sans KR', system-ui, -apple-system, sans-serif",
    boxSizing: "border-box",
  },
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  card: {
    background: "rgba(20, 20, 20, 0.88)",
    border: "1px solid rgba(255,255,255,0.07)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.32)",
    borderRadius: "18px",
    padding: "18px 16px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
    alignItems: "center",
    flexWrap: "wrap",
  },
  titleWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  badge: {
    background: "linear-gradient(120deg, #fb923c, #f97316)",
    color: "#130903",
    padding: "6px 12px",
    borderRadius: "999px",
    fontWeight: 800,
    fontSize: "12px",
    display: "inline-block",
    border: "1px solid rgba(255,255,255,0.12)",
  },
  title: {
    margin: 0,
    fontSize: "26px",
    fontWeight: 800,
    color: "#fff",
    letterSpacing: "-0.02em",
  },
  helper: {
    margin: 0,
    color: "#cbd5e1",
    fontSize: "13px",
    lineHeight: 1.5,
  },
  tagRow: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  },
  tag: {
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "10px",
    padding: "8px 10px",
    fontWeight: 700,
    color: "#f8fafc",
    fontSize: "13px",
  },
};

/** TRACK 총 투자 USDT 하한. 실버는 1000~10000(포함), 골드는 무제한 … 등으로 상한과 함께 쓰임 */
const MIN_TRACK_USDT = 1000;

export default function SinglePage() {
  const [cookies] = useCookies(['uuid']);
  const [socketData, setSocketData] = useState(null);

  const[uid,setUID] = useState(0);
  const[nickname,setNickname] = useState('');
  const [email, setEmail] = useState('');
  const [grade,setGrade] = useState('normal');
  const [ex_period,setExperiod] = useState('');

  const location = useLocation();
  const navigate = useNavigate();

  const [isTrading, setIsTrading] = useState(false);
  const [statusText, setStatusText] = useState("매매종료중");

  const [symbol,setSymbol] = useState('default');
  const [showConfirm, setShowConfirm] = useState(false);
  const [showConfirmStop, setShowConfirmStop] = useState(false);
  const [showConfirmStopYes, setShowConfirmStopYes] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');

  // ✅ 통합 USDT 입력값 (하나만 사용)
  const [total_usdt, setTotalUsdt] = useState(0);

  const [eth_check,setEthCheck] = useState('no')
  const [xrp_check,setXrpCheck] = useState('no')
  const [sol_check,setSolCheck] = useState('no')

  // ✅ 권한 확인
  const fetchUserInfo = (uuid) => {
      fetch(`/SetPage/user?uuid=${uuid}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('서버 응답 실패');
          }
          return response.json();
        })
        .then(data => {
          const user = data[0];
          setUID(user.uid);
          setNickname(user.nickname);
          setEmail(String(user.email ?? ''));
          setGrade(user.grade);
          setExperiod(user.ex_period);
          const possible = user.track_possible;
          const nickname = user.nickname;
          const grade = user.grade;
          const ex_period = user.ex_period;

          if (possible === '0' || possible === null || possible === 0){
            alert(`${nickname} 님은 TRACK version의 사용권한이 없습니다.`)
            navigate("/SelectPage");
            }

          let today = new Date();
          let targetDate = new Date(ex_period);
          let timeDiff = targetDate - today;
          let daysLeft = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
          let hoursLeft = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutesLeft = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
          if (timeDiff > 0 && daysLeft <= 5) {
              alert(`사용기한이 ${daysLeft}일 ${hoursLeft}시간 ${minutesLeft}분 남았습니다.\n` +
              `----------------------------------------------------------------------\n` +
              `※ 사용기한이 지나면 자동으로 종료됩니다.\n`+
              `※ 더이상 프로그램 사용을 원치 않으시면 진입중인 포지션은 미리 정리해주세요!\n`+
              `※ 정리하지 않은 포지션은 더이상 자동으로 포지션을 잡거나 정리하지 않습니다.`)
          } else if (timeDiff <= 0) {
              alert("사용기한이 만료되었습니다.");
              navigate("/SelectPage");
          }
        })
        .catch(error => {
          alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
          navigate("/LoginAts", { replace: true });
        });
    };

  // ✅ uuid / 경로 변경될 때마다 권한 체크
  useEffect(() => {
    if (!cookies.uuid) {
      alert("로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.");
      navigate("/LoginAts", { replace: true });
    } else {
      fetchUserInfo(cookies.uuid);
    }
  }, [cookies.uuid, location.pathname]);


  useEffect(() => {
  if (!uid) return;

  const WS_URL =
    window.location.hostname === "127.0.0.1"
      ? "ws://127.0.0.1:8000/ws_track"
      : "wss://speedbotpro.com/ws_track";

  let ws;
  let reconnectTimer;
  let isUnmounted = false;

  const connectWebSocket = () => {
    ws = new WebSocket(WS_URL);

    ws.onopen = () => {
      console.log("✅ 웹소켓 연결 성공:", WS_URL);
      ws.send(JSON.stringify({ type: "init", uid }));
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        switch (data.symbol) {
          case 'ETH/USDT:USDT':
            setEthCheck(data.start_check);
            break;
          case 'XRP/USDT:USDT':
            setXrpCheck(data.start_check);
            break;
          case 'SOL/USDT:USDT':
            setSolCheck(data.start_check);
            break;
          default:
            break;
        }
      } catch (err) {
        console.error("⚠️ JSON 파싱 오류:", err);
      }
    };

    ws.onerror = (error) => {
      console.error("❌ 웹소켓 에러:", error);
    };

    ws.onclose = (event) => {
      console.warn("🔌 웹소켓 연결 종료:", event.code);
      if (!isUnmounted && (event.code === 1006 || event.code === 426)) {
        console.log("🔁 5초 후 재연결 시도...");
        reconnectTimer = setTimeout(connectWebSocket, 5000);
      }
    };
  };

  connectWebSocket();

  onClickSearch();

  return () => {
    isUnmounted = true;
    if (reconnectTimer) clearTimeout(reconnectTimer);
    if (ws) ws.close();
  };
}, [uid]);


useEffect(() => {
    const active = eth_check === "apply" && xrp_check === "apply" && sol_check === "apply";
    setIsTrading(active);
    setStatusText(active ? "자동매매중..." : "매매종료중");
}, [eth_check, xrp_check, sol_check]);

  //////////////////////////////////////////////////////////

  const[total_usdt_Valid, setTotalUsdtValid] = useState(true);
  const[notAllow, setNotAllow] = useState(true);

  // 유효성 검사
  const handleTotalUsdt = (e) => {
    const newusdt = e.target.value.trim();
    setTotalUsdt(newusdt);

    const regex = /^-?\d*(\.\d+)?$/;
    if (regex.test(newusdt)) {
      setTotalUsdtValid(true);
    } else {
      setTotalUsdtValid(false);
    }
  };

  /////////////////////////////////////////////////////////////////

  useEffect(() => {
    if (total_usdt_Valid) {
      setNotAllow(false);
      return;
    }
    setNotAllow(true);
  }, [total_usdt_Valid]);

  const getTrackMaxUsdtByGrade = (g) => {
    if (g === "normal") return null;
    if (g === "silver") return 10000;
    if (g === "gold") return 99999999999;
    if (g === "diamond") return 99999999999;
    return null;
  };

  /** null 이면 통과, 아니면 거절 사유 문구 */
  const getTrackUsdtRangeError = (coin_usdt) => {
    if (grade === "normal") {
      return "normal 등급은 USDT 셋팅이 불가합니다. (실버 이상 등급 필요)";
    }
    if (!Number.isFinite(coin_usdt) || coin_usdt < MIN_TRACK_USDT) {
      return `USDT는 ${MIN_TRACK_USDT} 이상만 셋팅 가능합니다. (현재 입력: ${total_usdt})`;
    }
    const maxUsdt = getTrackMaxUsdtByGrade(grade);
    if (maxUsdt != null && coin_usdt > maxUsdt) {
      return `${nickname}님은 ${maxUsdt}까지 셋팅 가능합니다. 현재 입력값은 ${coin_usdt}입니다.`;
    }
    return null;
  };

  const applyTrackRowsToState = (result) => {
    if (!result || !Array.isArray(result)) return;
    const eth = result.find((item) => item.symbol.startsWith("ETH/USDT"));
    const xrp = result.find((item) => item.symbol.startsWith("XRP/USDT"));
    const sol = result.find((item) => item.symbol.startsWith("SOL/USDT"));
    if (eth) {
      setTotalUsdt(eth.total_usdt);
      setEthCheck(eth.start_check);
    }
    if (xrp) {
      setXrpCheck(xrp.start_check);
    }
    if (sol) {
      setSolCheck(sol.start_check);
    }
  };

  const onClickSearch = () => {
    if (!uid) return;
    console.log(uid);
    fetch(`/coin_search_track/${uid}`)
    .then((response) => {
      if(!response.ok) {
        throw new Error('400 아니면 500 에러남');
      }
      return response.json()
    })
    .then((result) => {
      console.log('db에서 성공적으로 데이터 받아옴');
      applyTrackRowsToState(result);
    })
    .catch((error) => {
      console.log('에러남');
    })
  }

  const onClickStart = () => {
    const coin_usdt = Number(total_usdt);
    console.log("투자금액:", coin_usdt);

    const rangeErr = getTrackUsdtRangeError(coin_usdt);
    if (rangeErr) {
      alert(rangeErr);
      onClickSearch();
      return;
    }

    const isApplied = eth_check === 'apply' && xrp_check === 'apply' && sol_check === 'apply';
    if (isApplied) {
      setConfirmMessage('입력값을 수정할까요?');
    } else {
      setConfirmMessage('셋팅값으로 매매를 진행할까요?');
    }
    setShowConfirm(true);
  };

  const handleCancel = () => {
    setShowConfirm(false);
    console.log('매매 취소');
    onClickSearch();
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    console.log('셋팅값으로 매매를 진행합니다.');

    const coin_usdt = Number(total_usdt);

    if (coin_usdt <= 0) {
      window.alert("양수만 입력가능합니다.");
      onClickSearch();
      return;
    }
    const rangeErr = getTrackUsdtRangeError(coin_usdt);
    if (rangeErr) {
      window.alert(rangeErr);
      onClickSearch();
      return;
    }
    fetch("/set_start_symbol_track", {
      method : 'POST',
      headers: {
        'Content-Type' : 'application/json',
      },
      body: JSON.stringify({
        uid,
        coin_usdt
        }),
      })
      .then(response => response.json())
      .then(data => {
        onClickSearch();
      })
      .catch(error => console.error('Error:', error));
  };

  const onClickStop = () => {
    setConfirmMessage('매매를 종료할까요?');
    setShowConfirmStop(true);
  };

  const handleCancelStop = () => {
    setShowConfirmStop(false);
    console.log('종료 취소');
  };

  const handleConfirmStop = () => {
    setShowConfirmStop(false);
    console.log('매매를 종료합니다.');
    fetch('/set_start_symbol_stop_track', {
      method : 'POST',
      headers: {
        'Content-Type' : 'application/json',
      },
      body: JSON.stringify({
        uid
        }),
      })
      .then(response => response.json())
      .then(data => {
        setConfirmMessage(data.message)
        setShowConfirmStopYes(true);
        onClickSearch();
      })
      .catch(error => console.error('Error:', error));
  };

  const handleConfirmStopYes= () => {
    setShowConfirmStopYes(false);
    console.log('포지션 정리 확인');
  };

  //로그아웃
  const onClickEnd = () => {
    const uuid = cookies.uuid;
    if (!uuid) {
      alert('로그인 정보가 존재하지 않습니다.');
      return;
    }
    fetch('/logout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ userId: uuid })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('로그아웃 요청 실패');
      }
      console.log('로그아웃 성공');
      alert('Logout is successful.');
      window.location.href = '/';
    })
    .catch(error => {
      console.error('로그아웃 요청 중 오류 발생:', error);
    });
  }

  return (
      <div style={styles.page}>
        <div style={styles.container}>
          <div style={styles.headerRow}>
            <div style={styles.titleWrap}>
              <span style={styles.badge}>Speed BOT</span>
              <h1 style={styles.title}>Auto Trade System</h1>
              <p style={styles.helper}>실시간 시그널과 자동매매 상태를 확인하세요.</p>
            </div>
            <div style={styles.tagRow}>
              <span style={styles.tag}>UID: {uid}</span>
              <span style={styles.tag}>GRADE: {grade?.toUpperCase() || "-"}</span>
              <span style={styles.tag}>사용기한: {ex_period || "-"}</span>
              <span style={styles.tag}>Nickname: {nickname || "-"}</span>
              <span style={styles.tag}>{email || "-"}</span>
              <button
                style={{
                  padding: "10px 12px",
                  borderRadius: "10px",
                  border: "1px solid rgba(255,255,255,0.12)",
                  background: "rgba(255,255,255,0.06)",
                  color: "#f8fafc",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
                onClick={() => navigate("/SelectPage")}
              >
                ← SelectPage
              </button>
            </div>
          </div>

          <div className="container" style={styles.card}>
            <div className="column_leverage">
            <h1 style={styles.title}>TRACK version</h1>
            <div className="line"></div>

            {/* ✅ 통합 USDT 입력 */}
            <div className="leverage_container">
              <div className="leverage_item">총 투자금액</div>
              <div className="leverage_item">USDT</div>
              <input
                type="number"
                min={MIN_TRACK_USDT}
                step="1"
                className="leverage_input_basic"
                value={total_usdt}
                onChange={handleTotalUsdt}
                disabled={grade === "normal"}
                title={grade === "normal" ? "normal 등급은 USDT 셋팅이 불가합니다" : undefined}
              />
            </div>
            {grade === "normal" && (
              <p style={{ ...styles.helper, marginTop: 10, color: "#fbbf24" }}>
                normal 등급은 총 투자 USDT 셋팅·매매시작이 불가합니다. 실버 이상 등급에서 이용할 수
                있습니다.
              </p>
            )}

            <div className="line"></div>

              {/* ✅ 통합 매매 상태 표시 */}
              <div className={`trading-status ${isTrading ? 'active' : 'inactive'}`}>
                <span className={`pulse-dot ${isTrading ? 'active' : 'inactive'}`}></span>
                <span className="trading-text">{statusText}</span>
              </div>

            <div className="line"></div>

            {/* ✅ 통합 버튼 */}
            <div className="leverage_container">
              <button
                type="button"
                onClick={() => onClickStart()}
                disabled={grade === "normal"}
                className={`button_benefit_c_lever ${eth_check === 'apply' && xrp_check === 'apply' && sol_check === 'apply' ? 'button_benefit_c_lever--edit' : 'button_benefit_c_lever--start'}`}
              >
                {eth_check === 'apply' && xrp_check === 'apply' && sol_check === 'apply' ? '매매수정' : '매매시작'}
              </button>
              <button onClick={() => onClickStop()} className="button_benefit_c_lever">
                매매종료
              </button>
            </div>

            <div className="line"></div>

            <div className="button_benefit_leverage">
              <button onClick={() => onClickEnd()} disabled={notAllow} className="bottomButton_sp_lever">
                로그아웃
              </button>
            </div>
          </div>
        </div>

        {showConfirm && (
          <div className="confirm-overlay">
            <div className="confirm-box">
              <p className="confirm-message">
                {confirmMessage}
              </p>
              <div className="confirm-buttons">
                <button className="confirm-btn yes" onClick={handleConfirm}>확인</button>
                <button className="confirm-btn no" onClick={handleCancel}>취소</button>
              </div>
            </div>
          </div>
        )}

        {showConfirmStop && (
          <div className="confirm-overlay">
            <div className="confirm-box">
              <p className="confirm-message">
                {confirmMessage}
              </p>
              <div className="confirm-buttons">
                <button className="confirm-btn yes" onClick={handleConfirmStop}>확인</button>
                <button className="confirm-btn no" onClick={handleCancelStop}>취소</button>
              </div>
            </div>
          </div>
        )}

        {showConfirmStopYes && (
          <div className="confirm-overlay">
            <div className="confirm-box">
              <p className="confirm-message">
                {confirmMessage}
              </p>
              <div className="confirm-buttons">
                <button className="confirm-btn yes" onClick={handleConfirmStopYes}>확인</button>
              </div>
            </div>
          </div>
        )}
        </div>
      </div>
  );
}